import tacHelpers from '../tacHelpers';
import updateItem from './updateItem';

export function updateMultipleItems(state, items, parent, options) {
  let model = state;

  items.forEach((item, index, arr) => {
    let updParent;
    if (item.parentRef) {
      updParent = tacHelpers.getItem(model, item.parentRef);
      delete item.parentRef;
    } else if (parent) {
      updParent = tacHelpers.getItem(model, parent.itemid);
    }

    const localOptions = { ...options, ...item.localOptions };
    item.localOptions && delete item.localOptions;

    model = updateItem(model, item, updParent, {
      keepParts: localOptions?.keepParts,
      moveOthers: localOptions?.moveOthers,
      postponeSort: localOptions?.hasDependencies || index < arr.length - 1,
      forceParts:
        localOptions?.forceParts ||
        (localOptions?.forcePartsOnFirstItem && index === 0),
      partsToSkip: localOptions?.partsToSkip || [],
      isPersistent: localOptions?.isPersistent,
    });
  });

  return model;
}
